
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_URL from "../../config/api";
import "./userList.css";

const UserList = () => {
  const [data, setData] = useState([]);

 
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(`${API_URL}/api/users`);
        const users = await res.json();

      
        const formattedUsers = users.map((user) => ({
          id: user.id || user._id,
          username: user.name,
          email: user.email,
          status: user.status || "active",
          transaction: user.transaction || "N/A",
          avatar: user.avatar || "/default.png",
        }));

        setData(formattedUsers);
      } catch (err) {
        console.error("Failed to fetch users", err);
      }
    };

    fetchUsers();
  }, []);

 
  const handleDelete = async (id) => {
    try {
      await fetch(`${API_URL}/api/users/${id}`, {
        method: "DELETE",
      });

      setData((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },

    {
      field: "user",
      headerName: "User",
      width: 220,
      renderCell: (params) => {
        return (
          <div className="userListUser">
            <img
              src={params.row.avatar}
              alt=""
              className="userListImg"
            />
            {params.row.username}
          </div>
        );
      },
    },

    { field: "email", headerName: "Email", width: 220 },

    {
      field: "status",
      headerName: "Status",
      width: 120,
    },

    {
      field: "transaction",
      headerName: "Transaction",
      width: 160,
    },

    {
      field: "action",
      headerName: "Action",
      width: 180,
      renderCell: (params) => {
        return (
          <>
            <Link to={`/user/${params.row.id}`}>
              <button className="userListEdit">Edit</button>
            </Link>

            <DeleteOutlineIcon
              className="userListDelete"
              onClick={() => handleDelete(params.row.id)}
            />
          </>
        );
      },
    },
  ];

  return (
    <div className="userList">
      <DataGrid
        rows={data}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        autoHeight

     
        initialState={{
          pagination: {
            paginationModel: { pageSize: 8, page: 0 },
          },
        }}
        pageSizeOptions={[5, 8, 10]}
      />
    </div>
  );
};

export default UserList;